export default __webpack_public_path__ + "static/media/queuing-sound.9ceb7030.wav";